import AxiosFoundationAPI from "../../../../util/AxiosFoundationAPI";
import EnterpriseComponent from "../../EnterpriseComponent";
import {V1ObjectTypeIDOCToArray} from "../../../../util/Payload";

// The kinds of change order this tenant defines -- "Engineering Change Order", "Document Change
// Order" -- each carrying its own form and its own approval matrix cell.
//
// THESE ARE OBJECT TYPES. A change order is typed exactly as a record is, so its kinds live in
// raw.OBJECT_TYPE with OBJECT_CLASSIFICATION 'ChangeOrder' and are served by the ordinary
// object_types endpoint. The classification filter below is the whole difference between this
// component and a document type picker, which is why it is fixed here rather than asked for.
//
// READ ONLY. Types are configuration, administered on their own screen; raising a change order only
// ever picks from them.
const URL = "t1/v1/object_types";
const IDOC = "v1.ObjectType-001";

class ChangeOrderTypeEnterpriseComponent extends EnterpriseComponent {

    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        const idocResponse = this.getIDOCResponse() ?? IDOC;

        AxiosFoundationAPI({
            method: "GET",
            url: URL,
            json: true,
            // THROUGH QUERY PARAMETERS, NOT A QBE. The endpoint takes ObjectClassification directly
            // and every other consumer of it does the same; building a QBE to say one thing the API
            // already asks for would be a second way to express the same filter.
            params: {
                "ObjectClassification": "ChangeOrder",
                "Limit": pageSize,
                "Offset": (page - 1) * pageSize,
                "Sort": this.getFormattedSortSpecification(),
            },
            headers: {"idoc-response": idocResponse},
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1ObjectTypeIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };
}

export default ChangeOrderTypeEnterpriseComponent;
